import { GeneralShape } from '../../shape/shapes/general/general-shape';
import { BaseAnimationFrame } from '../components/animation-frame/animation.types';
import { AnimationFrameObject } from './animation-frame-object';

export class BaseAnimationFrameObject extends AnimationFrameObject<BaseAnimationFrame> {
  get targetShape(): GeneralShape {
    return this.shapeService.getShapeByIRI(this.frame.targetShape);
  }
  startAnimations(numberOfBatches: number, timeScale: number): void {}

  async executeAnimation(_timeScale: number): Promise<void> {
    if (this.frame.alignment) {
      // -- // -- //
      // this.targetShape.doAlign(this.frame.alignment, { noResize: true });
      this.targetShape.doAlign(this.frame.alignment);
    }
    const start = performance.now();
    console.log('base-animation-frame-start');
    await this.targetShape.baseAnimate(this.frame.action);
    console.log('base-animation-frame-end', performance.now() - start);
  }

  endAnimations(): void {
    this.targetShape.endBaseAnimation();
  }
}
